<template>
    <div class="analytics-currency-filter">
        <div class="input-row">
            <ds-input-field
                v-model.trim="startPrice"
                type="number"
                :step="0.01"
            />

            <ds-input-field
                v-if="isBetween"
                v-model.trim="endPrice"
                type="number"
                :step="0.01"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
    },

    data() {
        return {
            filter: this.value,
            startPrice: '',
            endPrice: '',
        };
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },

        filter: {
            handler() {
                [this.startPrice, this.endPrice] = this.filter.value.split('|');
            },
            deep: true,
        },

        startPrice() {
            this.updateQuery();
        },

        endPrice() {
            this.updateQuery();
        },

        'filter.modifier': function() {
            this.updateQuery();
        },
    },

    computed: {
        isBetween() {
            return this.filter.modifier === 'between';
        },
    },

    methods: {
        updateQuery() {
            let query = '';

            switch (this.filter.modifier) {
            case 'greaterthan':
                query = `>${this.startPrice}`;
                break;
            case 'lessthan':
                query = `<${this.startPrice}`;
                break;
            case 'between':
                query = `${this.startPrice} to ${this.endPrice}`;
                break;
            case 'equals':
                query = this.startPrice;
                break;
            default:
                break;
            }

            this.filter.query = query;
            this.filter.value = `${this.startPrice}|${this.endPrice}`;
        },
    },
};
</script>

<style lang="scss" scoped>
    .input-row {
        display: flex;

        > *:not(:last-child) {
            margin-right: $spacing-200;
        }
    }

    @media screen and ($small) {
        .input-row {
            flex-direction: column;
        }
    }
</style>
